import { render, staticRenderFns } from "./ChoixRisque.vue?vue&type=template&id=b7defef8&scoped=true&"
import script from "./ChoixRisque.vue?vue&type=script&lang=js&"
export * from "./ChoixRisque.vue?vue&type=script&lang=js&"
import style0 from "./ChoixRisque.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ChoixRisque.vue?vue&type=style&index=1&id=b7defef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7defef8",
  null
  
)

export default component.exports